module.exports = __webpack_public_path__ + "img/br.8bcede61.svg";